import { createReducer, on } from '@ngrx/store';
import { OrderDetailsActions } from '../actions';
import { EntryDetailsState } from '../order-details.state';


export const initialState: EntryDetailsState = {
  success: null,
  loading: null,
  error: null,
  entrynumber:null
};

export const deleteEntryOrderDetailsReducer = createReducer(
  initialState,

  on(OrderDetailsActions.entryOrderdetails, (state) => {
    return ({
      ...state,
      loading: true,
      error: null,
    })
  }),

  on(OrderDetailsActions.entryOrderdetailsSuccess, (state, { success }) => {
    return ({
      ...state,
      success,
      loading: null,
      error: null,
    })
  }),

  on(OrderDetailsActions.entryOrderdetailsFail, (state, { payload }) => {
    return ({
      ...state,
      loading: null,
      error: payload,
    })
  }),

  on(OrderDetailsActions.entryNumber, (state, { entrynumber }) => {
    return ({
      ...state,
      entrynumber
    })
  }),

  
);
